module.exports = __webpack_public_path__ + "img/tabbed-search-filter-toyota.2890cee8.png";